import { render, staticRenderFns } from "./SkinSetWorkshopIdDialog.vue?vue&type=template&id=23831e1a&scoped=true&"
import script from "./SkinSetWorkshopIdDialog.vue?vue&type=script&lang=ts&"
export * from "./SkinSetWorkshopIdDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23831e1a",
  null
  
)

export default component.exports